import { lazy } from 'react';

export const VendorsList = lazy(() => import('./pages/VendorsList'));
export const VendorForm = lazy(() => import('./pages/VendorForm'));

export { VENDOR_ROUTES } from './paths';
